module.exports = __webpack_public_path__ + "static/media/ACIProductInfo.ab7e6791.jpg";